import { Controller } from 'stimulus'

export default class extends Controller {
  
  connect() {}


  disableClick() {
 //   var isAdventCalendarSelectionMode = (new URL(location.href)).serchParams.get("select_products_for_advent_calendar")

 //   if (!!isAdventCalendarSelectionMode) {
 //     this.element.classList.add("grayscale", "filter", "pointer-events-none");
 //   }
  }

}
